<template>
  <div v-loading="loading">
    <!-- 列表 -->
    <div v-loading="listConfig.loading">
      <charts-table
          v-if="listConfig.chartType"
          :chartType="listConfig.chartType"
          :chartData="listConfig">
      </charts-table>
      <list-table
        v-else
        :index="index"
        :tableData="listConfig.list_data"
        :column="listConfig.column"
        :pageSizes="listConfig.pagination"
        :pageCount="listConfig.list_pages"
        :currentPage="listConfig.currentPage"
        :currentSize="listConfig.currentSize"
        :freezeColumn="listConfig.freeze_column"
        :total="listConfig.list_count"
        :hasOrder="listConfig.is_serial == 1"
        :operationCount="getOperationCount()"
        :isShow="showBtn"
        @selectChange="selectChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        @jumpPage="jumpPage"
        @showRelate="showRelate"
        @sendParams="sendParams"
        @downloadItem="downloadItem"
        @sortTable="sortTable">
        <template>
          <!-- 筛选区 -->
          <template slot="header-left" v-show="hasCommonFilter || hasCombinationFilter || hasAdvanceFilter">
              <div v-show="hasCommonFilter" class="m-r-10 m-b-5 fl" v-for="(filter, index) in commonFilter">
                <el-input
                    class="h-40 w-200"
                    :placeholder="filter.name"
                    v-model="commonFilterData[index].value"
                    v-if="filter.type == FILTER_INPUT">
                </el-input>
                <el-select
                    :placeholder="filter.name"
                    :multiple="filter.is_multiple == 1"
                    :filterable="true"
                    clearable
                    v-model="commonFilterData[index].value"
                    v-if="filter.type == FILTER_SELECT || filter.type == FILTER_FOREIGNKEY">
                  <el-option
                      v-for="option in filter.field_config.select_option"
                      :key="option"
                      :label="option.name"
                      :value="option.value">
                  </el-option>
                </el-select>
                <range-filter
                    :placeholder="filter.name"
                    v-model="commonFilterData[index]"
                    v-if="filter.type == FILTER_RANGE">
                </range-filter>
                <datetimerange-filter
                    :placeholder="filter.name"
                    v-model="commonFilterData[index].value"
                    v-if="filter.type == FILTER_DATERANGE">
                </datetimerange-filter>
                <!-- <el-select
                    :placeholder="filter.name"
                    :filterable="true"
                    clearable
                    v-model="commonFilterData[index].value"
                    v-if="filter.type == FILTER_FOREIGNKEY">
                  <el-option
                      v-for="option in filter.keyOptions"
                      :key="option"
                      :label="option.name"
                      :value="option.id">
                  </el-option>
                </el-select> -->
              </div>
              <div class="m-r-10 m-b-5 fl">
                <el-button type="primary" @click="normalSearch" v-if="hasCommonFilter">搜索</el-button>
                <el-button type="primary" @click="openAdvanceDialog" v-if="hasAdvanceFilter">高级筛选</el-button>
              </div>
            <!--Todo组合筛选测试-->
            <div class="m-r-10 m-b-5 inline-block" v-show="hasCombinationFilter">
              <el-select
                v-show="hasCombinationSelect"
                v-model="combinationNumber"
                placeholder="请选择组合筛选"
                clearable
                @change="combinationChange">
                <el-option
                    v-for="(item,index) in combinationList"
                    :key=item
                    :label="item.name"
                    :value="index"></el-option>
              </el-select>
              <el-button v-show="hasCombinationButton" type="primary" @click="openCombinationDialog">配置组合筛选</el-button>
            </div>
          </template>
          <!-- 筛选区 -->
          <!-- 列表外按钮区 -->
          <el-tabs
            class="m-b-0 tab-border"
            v-if='showTabLeftBtns'
            v-model="curTabLeftBtnName"
            slot="header-left-screening"
            @tab-click="setActiveName">
            <el-tab-pane
              v-for="deal in listConfig.handle"
              v-if="deal.type != OPERATION_SELF && deal.type == OPERATION_FILTER"
              :label="deal.name"
              :name="deal.name">
            </el-tab-pane>
          </el-tabs>
          <div class="inline-block btn-wrapper m-b-5"
               v-for="deal in listConfig.handle"
               v-if="deal.type != OPERATION_FILTER"
               :slot="getSlotName(deal.pos, deal.type)">
            <el-button
              :type="getBtnType(deal.show_type)"
              :size="getSizeByPos(deal.pos)"
              @click="dealBtnEvent(deal, null, listConfig)"
              v-if="deal.type != OPERATION_SELF && deal.type != OPERATION_IMPORT && !(deal.type == OPERATION_FILTER && deal.pos == POS_LEFT_TOP)">
              {{ deal.name }}
            </el-button>
            <el-button
              :type="getBtnType(deal.show_type)"
              :size="getSizeByPos(deal.pos)"
              @click="dealBtnEvent(deal, null, listConfig)"
              v-if="deal.type == OPERATION_IMPORT && getBtnShowType(deal.type, deal) == 'default' && deal.type != OPERATION_FILTER">
              {{ deal.name }}
            </el-button>
            <dropdown-render
              :btnName="deal.name"
              :deal="deal"
              :dropData="getDropData(deal)"
              @dropdownEvent="dropdownEvent"
              v-if="deal.type == OPERATION_IMPORT && getBtnShowType(deal.type, deal) == 'dropdown' && deal.type != OPERATION_FILTER">
            </dropdown-render>
            <self-render
              :iden="deal.iden"
              v-if="deal.type == OPERATION_SELF"
              :selfData="selfData"
              @getSelfData="getSelfDataCallback">
            </self-render>
          </div>
        </template>
        <!-- 列表外按钮区 -->
        <template slot="table" scope="scope">
          <div class="inline-block btn-wrapper"
               v-for="deal in listConfig.inner_handle">
            <el-button
              :type="getBtnType(deal.show_type)"
              size="small"
              :disabled="checkForbiden(scope.row, deal.id)"
              @click="dealBtnEvent(deal, scope.row, listConfig)"
              v-if="deal.type != OPERATION_SELF && checkVisible(scope.row, deal.id)">
              {{ deal.name }}
            </el-button>
            <self-render
              :iden="deal.iden"
              v-if="deal.type == OPERATION_SELF"
              :selfData="selfData"
              @getSelfData="getSelfDataCallback">
            </self-render>
          </div>
          <div class="inline-block btn-wrapper"
               v-for="deal in listConfig.self_handle"
              v-if="scope.row[deal.iden] != DEAL_AUTH_NOUSE">
            <el-button
              type="self"
              size="small"
              @click="dealSelfHandle(deal, scope.row)"
              v-if="deal.btn_color && deal.font_color"
              :disabled="scope.row[deal.iden] == DEAL_AUTH_DISABLED"
              :style="{
                  backgroundColor: deal.btn_color,
                  color: deal.font_color
                }">{{ deal.name }}</el-button>
              <el-button
                size="small"
                @click="dealSelfHandle(deal, scope.row)"
                :disabled="scope.row[deal.iden] == DEAL_AUTH_DISABLED"
                v-else>{{ deal.name }}</el-button>
          </div>
        </template>
      </list-table>
    </div>
    <!-- 列表 -->
    <!-- 操作实例化组件 -->
    <edit-deal ref="editDeal" :source="editSource" @editCallback="editCallback"></edit-deal>
    <delete-deal ref="deleteDeal" :source="deleteSource" @deleteCallback="deleteCallback"></delete-deal>
    <import-deal ref="importDeal" :query="listQuery" :source="importSource" :isQueryGet="isQueryGet" @importCallback="importCallback" @setLoading="setLoading"></import-deal>
    <export-deal ref="exportDeal" :source="exportSource" :dealId="dealId"></export-deal>
    <email-deal ref="emailDeal" :source="emailSource" @emailCallback="emailCallback"></email-deal>
    <status-deal ref="statusDeal" :source="statusSource" @statusCallback="statusCallback"></status-deal>
    <relate-deal ref="relateDeal" :source="relateSource"></relate-deal>
    <!-- 操作实例化组件 -->
    <!--组合筛选对话框-->
    <combination-dialog
        ref="combination"
        :tempCombinationData="combinationData"
        :dealId='dealId'
        :listModelId='listModelId'
        :filterFieldIds='filterFieldIds'
        @handleParams="handleParams">
    </combination-dialog>
    <importlog-dialog
      ref="importlog"
      :tempImportlogData="importlogData"
      :importId='operation_import_id'
      :contentId="contentId"
      @handleParams="handleParams">
    </importlog-dialog>
    <repeat-dialog
      ref="repeat"
      :repeatDetail="repeatDetail"
      :importId='operation_import_id'
      :contentId="contentId"
      @handleRepeat="handleRepeat">
    </repeat-dialog>
    <advance-dialog
      ref="advance"
      :advance-filter="advanceFilter"
      :filter-data="advanceFilterData"
      @handleAdvance="advanceSearch">
    </advance-dialog>
    <render-dialog
      ref="renderDialog"
      :contentId="renderSource.contentId"
      :dataId="renderSource.dataId"
      :query="renderSource.query">
    </render-dialog>
    <!-- 下载文件按钮，隐藏不显示 -->
    <a :href="downloadUrl" id="mydown" class="hideDownloadBtn">下载链接</a>
  </div>
</template>
<style scope>
  .el-tabs__nav{
    margin-left: 50px !important;
  }
  .el-tabs__item.is-active {
    font-weight: bold;
  }
  .el-tabs__header{
    margin: 0 0 20px;
  }
  .el-tabs__item{
    height: 60px;
    line-height: 60px;
    padding: 0 16px;
  }
  .el-tabs__header{
    border-bottom: 0px !important;
    background: #fff !important;
  }
  .el-tabs__active-bar{
    height: 4px !important;
  }
  .el-button--success.is-plain.filter-btn {
    background: #fff;
    border-color: #13ce66 !important;
    color: #13ce66 !important;
  }
  .el-button.is-plain:focus {
    background: #fff;
    border: 1px solid #bfcbd9;
    color: #1f2d3d;
  }
  .hideDownloadBtn{
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 0;
    opacity: 0
  }
  .ovf-hd > .el-dialog {
    overflow: hidden !important;
  }
  .el-tabs.tab-border {
    border: 1px solid #dfe6ec;
    border-bottom: 0;
  }
  .el-tabs.m-b-0 .el-tabs__header {
    margin-bottom: 0 !important;
  }
</style>
<script>
  /**
   * @author duoremix
   * @param Number ContentId 功能集Id
   * @param Number dealId 功能点id
   * @param Object query 跳转带来的参数
   */
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  import dealMethod from './mixins/dealMethod'  // 执行各操作的方法集合
  import dealCallback from './mixins/dealCallback'  // 执行各操作的回调集合
  import listTable from './listTable'
  import chartsTable from './chart/chartsTable'
  import editDeal from './deal/editDeal'
  import deleteDeal from './deal/deleteDeal'
  import statusDeal from './deal/statusDeal'
  import importDeal from './deal/importDeal'
  import repeatDialog from './repeatDialog.vue'
  import exportDeal from './deal/exportDeal'
  import relateDeal from './deal/relateDeal'
  import emailDeal from './deal/emailDeal'
  import rangeFilter from '../../Common/business/filter/rangeFilter'
  import datetimerangeFilter from '../../Common/business/filter/datetimerangeFilter'
  import combinationDialog from './combinationDialog.vue'
  import renderDialog from './renderDialog'
  import importlogDialog from './importlogDialog.vue'
  import advanceDialog from './advanceDialog.vue'
  import selfRender from './selfRender.vue'
  import dropdownRender from './dropdownRender.vue'
  import base64 from 'base-64'
  import utf8 from 'utf8'
  export default {
    name: 'listRender',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      },
      query: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        commonConfig: '', // 公共区配置
        check_change: 0, // 判断列表数据字段是否进行对比
        filterData: [],  // 筛选数据的条件(搜索的时候替换普通筛选个高级筛选)
        downloadUrl: '',
        newTab: '',
        resetFailIds: false,
        isComplete: false,   // 是否已完成数据加载
        // contentId: '',
        listConfig: {}, // 列表配置
        loading: false,
        isJump: '',
        listQuery: '',
        commonFilterData: [], // 普通筛选数据
        advanceFilterData: [], // 高级筛选数据
        combinationData: {
          use_auth: '',
          build_auth: '',
          filter_fields: [],
          is_open: 1,
          select_map: []
        }, // 配置组合筛选条件
        combinationList: [], // 组合筛选下拉框选择列表
        importlogData: {},
        repeatDetail: {},
        operation_import_id: 0,
        isQueryGet: 0, // 判断导入文件时，是否传参
        combinationNumber: null, // 组合筛选选择id
        showCombination: false,
        showBtn: false, // 是否显示操作按钮div
        showTabLeftBtns: false,
        curTabLeftBtnName: '',
        renderSource: {
          contentId: 0,
          dataId: 0,
          query: {}
        },
        listModelId: '',
        filterFieldIds: [],
        selfData: {} // 自定义数据返回
      }
    },
    methods: {
      setActiveName(tab, e) { // 设置tab的内容
        _(this.listConfig.handle).forEach((handle) => {
          if (handle.name == tab.name) {
            this.dealBtnEvent(handle, null, this.listConfig)
            return false
          }
        })
      },
      getListConfig() { // 获取列表数据
        let postData = ''
        if (this.isJump) {  // 如果是跳转页面，带上参数
          postData = {
            params: {
              is_jump: 1,
              query: this.listQuery
            }
          }
        }
        this.isComplete = false
        this.apiGet(`cms/contents/${this.contentId}/list/${this.dealId}`, postData).then((res) => {
          if (res.code == 200) {
            let column = []
            let listConfig = res.data
            listConfig.loading = false
            if (listConfig.pagination) {  // 处理分页
              listConfig.pagination = listConfig.pagination.replace(/\s/g, '').split(',')
              _(listConfig.pagination).forEach((page, index) => {
                listConfig.pagination[index] = parseInt(page)
              })
            } else {
              listConfig.pagination = [15]
            }
            listConfig.currentTag = { // 初始化筛选标签
              id: '',
              condition: {}
            }
            listConfig.currentPage = 1
            if (listConfig.is_page == 1) { // 开启分页
              listConfig.currentSize = listConfig.pagination[0]
            } else {
              listConfig.currentSize = listConfig.list_limit ? listConfig.list_limit : 15
            }
            listConfig.filterData = []  // 初始化列表筛选数据
            // 获取组合筛选数据
            if (!(_.isEmpty(res.data.filter_build))) { // 该对象不为空
              this.combinationData = res.data.filter_build
              // if (_.isEmpty(this.combinationData.select_map)) { // 如果没有组合筛选条件 则添加一个
              //   this.combinationList = []
              //   this.combinationData.select_map = []
              //   let model = {
              //     fields: [{
              //       field_id: '',
              //       logic: 10,
              //       logic_map: 'AND',
              //       type: 10,
              //       value: ''
              //     }],
              //     name: '',
              //     relation: ''
              //   }
              //   this.combinationData.select_map.push(model)
              // } else {
              //   this.combinationList = this.combinationData.select_map
              // }
              this.combinationList = this.combinationData.select_map
              this.listModelId = listConfig.list_model_id
              this.filterFieldIds = listConfig.filter_build.filter_field_ids
            }
            listConfig.table_handle = _.cloneDeep(listConfig.inner_handle)
            _(listConfig.self_handle).forEach((res) => {
              res.handle_type = 'self'
              listConfig.table_handle.push(res)
            })
            _(res.data.filter).forEach((filter) => { // 为下拉加分页
              if (filter.type == this.FILTER_SELECT ||
                  filter.type == this.FILTER_FOREIGNKEY ||
                  filter.type == this.FILTER_RELATEX_TEXT) {
                this.$set(filter, 'curPage', 1)
                filter.field_config.allOptions = _.cloneDeep(filter.field_config.select_option)
              }
            })
            listConfig.filter = res.data.filter
            this.showBtn = listConfig.handle.length > 0 || listConfig.filter.length > 0
            this.check_change = listConfig.check_change
            listConfig.deal_col_width = Number(listConfig.deal_col_width)
            listConfig.freeze_column = parseInt(res.data.freeze_column)
            this.listConfig = listConfig
            // 判断listConfig.handle中的按钮，其插槽名是否有“header-left-screening”，有则显示tab
            if (this.listConfig.handle) {
              _(this.listConfig.handle).forEach((handle) => {
                if (this.getSlotName(handle.pos, handle.type) == 'header-left-screening') {
                  this.showTabLeftBtns = true
                  this.curTabLeftBtnName = handle.name
                  return false
                }
              })
              _(this.listConfig.handle).forEach((handle) => {
                if (handle.type == this.OPERATION_IMPORT) {
                  // this.operation_import_id = handle.id
                  this.isQueryGet = handle.is_query
                }
              })
            }
            let needSetLoading = true
            if (this.hasQueryFilter) { // 如果有搜索的参数
              if (this.filterQuery) {
                let filterQueryObj = JSON.parse(utf8.decode(base64.decode((this.filterQuery))))
                if (filterQueryObj && filterQueryObj[this.index]) { // 当前功能集有自带查询参数
                  let postData = filterQueryObj[this.index]
                  if (postData.sort) {
                    delete postData.sort
                  }
                  this.fillFilterInput(postData, this.listConfig) // 填充上筛选控件
                  this.getListData(postData, this.listConfig, true) // 获取数据
                  this.hasFilterData = true
                  needSetLoading = false
                }
              }
              this.hasQueryFilter = false
            }
            if (needSetLoading) {
              this.loading = false
            }
            this.getFailIdsFromVuex()
            setTimeout(() => {
              this.recoverFailSelection()
            })
          } else {
            _g.dealError(this, res)
            this.loading = false
          }
          this.isComplete = true
        })
      },
      async getKeyOptions(id, majorField) { // 获取外键选项
        let postData = {}
        if (majorField) {
          postData.major_field = majorField // 主字段
        }
        let res = await this.apiPost(`form/keys/${id}`, postData)
        let arr = []
        arr = this.promiseHandler(arr, res)
        return arr.marjorData
      },
      getSlotName(pos, type) {  // 根据操作配置位置设置插槽名
        let name = ''
        switch (pos) {
          case this.POS_LEFT_TOP:
            if (type == this.OPERATION_FILTER) {
              name = 'header-left-screening'
            } else {
              name = 'header-left'
            }
            break
          case this.POS_RIGHT_TOP:
            name = 'header-right'
            break
          case this.POS_LEFT_BOTTOM:
            name = 'footer'
            break
          default:
            name = 'header-left'
            break
        }
        return name
      },
      getSizeByPos(pos) {  // 根据位置获取按钮尺寸
        let size = ''
        switch (pos) {
          case this.POS_LEFT_TOP:
            size = ''
            break
            // case this.POS_RIGHT_TOP:
            //   size = ''
            //   break
          case this.POS_LEFT_BOTTOM:
            size = ''
            break
          default:
            size = ''
        }
        return size
      },
      getBtnType(type) {  // 根据操作类型设置按钮类型
        let btnType = ''
        switch (type) {
          case this.OPERATION_DELETE:
            btnType = 'default'
            break
          case this.OPERATION_EDIT:
            btnType = 'primary'
            break
          case this.OPERATION_DETAIL:
            btnType = 'default'
            break
          case this.OPERATION_STATUS:
            btnType = 'default'
            break
          case this.OPERATION_IMPORT:
            btnType = 'default'
            break
          case this.OPERATION_EXPORT:
            btnType = 'default'
            break
          case this.OPERATION_SEARCH:
            btnType = 'primary'
            break
          default:
            btnType = 'success'
            break
        }
        return btnType
      },
      getDropData(deal) {
        let dropData = []
        switch (deal.type) {
          case this.OPERATION_IMPORT:
            if (deal.excel_log == 1) {
              dropData.push({ title: '导入记录' })
            }
            if (deal.excel_url != '') {
              dropData.push({ title: '下载模板' })
            }
            break
          default:
            dropData = []
        }
        return dropData
      },
      getBtnShowType(operationType, deal) {  // 判断按钮显示的类型
        let type = ''
        switch (operationType) {
          case this.OPERATION_IMPORT:
            if (deal.excel_log == 1 || deal.excel_url != '') {
              type = 'dropdown'
            } else {
              type = 'default'
            }
            break
          default:
            type = 'default'
        }
        return type
      },
      dropdownEvent(res) {
        if (res.title == '导入记录') {
          this.openImportLogDialog(this.contentId, res.deal.id)
        } else if (res.title == '下载模板') {
          this.downloadTemplate(res.deal)
        } else {
          this.dealBtnEvent(res.deal, null)
        }
      },
      getBtnTypeByPos(pos) {  // 根据位置获取按钮类型
        let type = ''
        switch (pos) {
          case this.POS_LEFT_TOP:
            type = 'success'
            break
          case this.POS_RIGHT_TOP:
            type = 'success'
            break
          case this.POS_LEFT_BOTTOM:
            type = 'default'
            break
          default:
            type = 'default'
        }
        return type
      },
      dealSelfHandle(deal, row) { // 操作区自定义操作配置
        let encodeQuery = ''
        switch (deal.deal_type) {
          case this.SELFHANDLE_LINK: // 外链
            let newWin = window.open('', '_blank')
            newWin.location = deal.url
            break
          case this.SELFHANDLE_DIALOG: // 弹窗跳转
            encodeQuery = this.makeQuery(row, deal.fields, deal.param)
            if (deal.reality) {
              this.renderSource.contentId = deal.reality.id
              this.renderSource.dataId = row.id
              this.renderSource.query = { is_jump: 1, dataId: row.id, query: encodeQuery }
              this.$refs.renderDialog.openDialog()
            }
            break
          case this.SELFHANDLE_PAGE: // 页面跳转
            encodeQuery = this.makeQuery(row, deal.fields, deal.param)
            if (deal.reality) {
              router.push({
                name: 'renderPage',
                params: { contentId: deal.reality.id },
                query: { is_jump: 1, dataId: row.id, query: encodeQuery }
              })
            }
            break
        }
      },
      makeQuery(row, fields, param) { // 生成query值
        let query = ''
        _(fields).forEach((item) => { // 根据配置生成query值
          query += `${item}=${row[`${param}`]}&`
        })
        query = query.substr(0, query.length - 1)
        let encodeQuery = base64.encode(utf8.encode(query)) // 进行base64转码
        return encodeQuery
      },
      commonSearch() {  // 公共区域的搜索操作
        this.filterData = this.commonFilterData.concat(this.advanceFilterData)
        this.searchItem(this.listConfig)
      },
      openAdvanceDialog() { // 点击高级筛选按钮
        this.$refs.advance.open()
      },
      combinationChange(val) { // 组合筛选功能
        this.commonSearch()
      },
      beforeGetListData(list) { // 获取列表数据前，构造搜索数据
        let postData = this.makeFilterData(list.filterData, list.currentTag.condition, list.currentPage, list.currentSize, list, this.combinationNumber)
        this.getListData(postData, list)
      },
      fillFilterInput(data, list) {
        if (data.limit) {
          list.currentSize = data.limit
          if (this.listConfig.pagination &&
              data.limit == this.listConfig.pagination[0]) {
            this.disableSizeChange = true
          }
        }
        if (data.page) {
          list.currentPage = data.page
          if (data.page && data.page != 1) {
            this.disablePageChange = true
          }
        }
        setTimeout(() => {
          this.doFillFilter(data, this.commonFilterData, this.listConfig)
          this.doFillFilter(data, this.advanceFilterData, this.listConfig)
          this.doFillCondition(data, this.listConfig)
          list.filterData = this.commonFilterData.concat(this.advanceFilterData)
        }, 200)
      },
      sortTable(name, sortType) { // 列表排序筛选数据
        let list = this.listConfig
        list.currentPage = 1
        let postData = this.makeFilterData(list.filterData, list.currentTag.condition, list.currentPage, list.currentSize, list, this.combinationNumber)
        let sort = []
        sort = this.getSortData(list.column, sort, name, sortType)
        postData.sort = sort
        this.getListData(postData, list)
      },
      getSortData(column, sort, name, sortType) { // 生成排序请求数据
        _(column).forEach((col) => {
          if (col.is_sort == 1) {
            if (col.field_name == name) {
              col.sortType = sortType
            }
            let thisSort = {
              field_name: col.field_name,
              sort: col.sortType
            }
            if (_g.isRealEmpty(sortType)) {
              delete thisSort.sort
            }
            sort.push(thisSort)
          }
          if (col.children) {
            sort = this.getSortData(col.children, sort, name, sortType)
          }
        })
        return sort
      },
      makeFilterData(filter, condition, page, size, list, combinationNumber) { // 构造搜索数据
        let hasFilterData = false
        let postData = {}
        // if (list.currentTag.id) {  // 使用筛选标签筛选
        //   postData = {
        //     condition: condition,
        //     page: page,
        //     limit: size
        //   }
        // } else {  // 使用搜索框筛选
        let stringFilter = []
        let selectFilter = []
        let rangeFilter = []
        let dateFilter = []
        let cloneFilter = _.cloneDeep(filter)
        // 分离下拉框筛选和其他筛选
        _(cloneFilter).forEach((res) => {
          if (res.exist) {
            return
          }
          if ((!_g.isRealEmpty(res.value) ||
              (!_g.isRealEmpty(res.from) ||
               !_g.isRealEmpty(res.to))) &&
              !hasFilterData) {
            hasFilterData = true
          }
          let typeSelect = res.type == this.FILTER_SELECT
          let typeForeignKey = res.type == this.FILTER_FOREIGNKEY
          let typeRange = res.type == this.FILTER_RANGE
          let typeDateRange = res.type == this.FILTER_DATERANGE
          let typeColroSelect = res.type == this.FILTER_COLOR_SELECT
          let isMultiple = res.isMultiple
          let typeTimeRange = res.type == this.FILTER_TIME_RANGE
          delete res.type
          delete res.isMultiple
          if (typeSelect) { // 若是下拉框筛选
            if (!isMultiple) { // 若非多选，把字符串放入数组中
              res.value = res.value || res.value === 0 ? [res.value] : ''
            }
            selectFilter.push(res)
          } else if (typeForeignKey) {  // 若是外键下拉框
            selectFilter.push(res)
          } else if (typeColroSelect) {
            // res.field = _.cloneDeep(res.field[0])
            selectFilter.push(res)
          } else if (typeRange && res.from !== '' && res.to !== '') { // 若是范围筛选
            rangeFilter.push(res)
          } else if (typeDateRange) {
            // res.from = res.value[0]
            // res.to = res.value[1]
            if (res.value) {
              res.from = res.value[0]
              res.to = res.value[1]
              delete res.value
            }
            rangeFilter.push(res)
          } else if (typeTimeRange) {
            if (res.value) {
              res.from = res.value[0]
              res.to = res.value[1]
              delete res.value
            }
            dateFilter.push(res)
          } else {  // 其他类型筛选
            stringFilter.push(res)
          }
        })
        postData = {
          filter: stringFilter,
          condition: condition,
          select: selectFilter,
          range: rangeFilter,
          page: page,
          limit: size,
          other: this.otherFilter,
          buildFilter: combinationNumber, // 组合筛选下拉框
          date_range: dateFilter // 时间范围控件
        }
        let sort = []
        sort = this.getSortData(list.column, sort)
        postData.sort = sort
        // }
        if (this.isJump) {  // 若是跳转，加上相关查询值
          postData.is_jump = 1
          postData.query = this.listQuery
        }
        this.hasFilterData = hasFilterData
        postData.tag_iden = list.currentTag.id
        this.setFilterQuery(postData)
        return postData
      },
      async getListData(postData, list, setLoading) { // 获取列表数据
        if (setLoading) {
          this.loading = true
        }
        let url = `cms/contents/${this.contentId}/searchlist/${list.id}`
        let res = await this.apiPost(url, postData)
        list.loading = false
        if (res.code == 200) {
          this.resetFailIds = false
          list.list_data = res.data.list
          list.list_count = res.data.dataCount
          list.list_pages = res.data.pageCount
          setTimeout(() => {
            this.recoverFailSelection()
          })
        } else {
          _g.dealError(this, res)
        }
        this.loading = false
      },
      getFilterCount(list, filterArr) { // 获取筛选标签新数量
        let buttonArr = list.handle
        let i = 0
        let j = 0
        for (i = 0; i < buttonArr.length;) {
          if (buttonArr[i].type != this.OPERATION_FILTER) {
            i++
            continue
          }
          for (j = 0; j < filterArr.length;) {
            if (buttonArr[i].id != filterArr[j].id) {
              i++
            } else {
              buttonArr[i].name = filterArr[j].name
              j++
            }
          }
          if (j >= filterArr.length) {
            break
          }
        }
      },
      getOperationCount() {
        let count = 0
        if (this.listConfig.inner_handle) {
          count += this.listConfig.inner_handle.length
        }
        if (this.listConfig.self_handle) {
          count += this.listConfig.self_handle.length
        }
        return count
      },
      /**
       * 检测操作按钮是否禁用
       * @param  {[Object]}
       * @param  {[Number]}
       * @return {[Boolean]}
       */
      checkForbiden(listData, handleId) {
        if (listData.forbiden_handle && listData.forbiden_handle.indexOf(handleId) >= 0) {
          return true
        } else {
          return false
        }
      },
      /**
       * 检测操作按钮是否隐藏
       * @param  {[Object]}
       * @param  {[Number]}
       * @return {[Boolean]}
       */
      checkVisible(listData, handleId) {
        if ((listData.invisible && listData.invisible.indexOf(handleId) >= 0)) {  // 不可见数组中存在
          return false
        } else {
          return true
        }
      },
      getFailIdsFromVuex() { // 从vuex获取失败选项数据
        let list = this.listConfig
        let key = `${this.contentId}_${list.id}`
        let failIds = store.state.contentFailIds[key]
        if (!_g.isRealEmpty(failIds)) {
          list.failMultiSelection = failIds
          store.dispatch('removeFailIds', key)
        }
      },
      recoverFailSelection() { // 恢复失败的选中项
        let list = this.listConfig
        if (!_g.isRealEmpty(list.failMultiSelection)) {
          list.multipleSelection = _.cloneDeep(list.failMultiSelection)
          _(list.list_data).forEach((res) => {
            if (_.indexOf(list.failMultiSelection, res.id) > -1) {
              this.resetFailIds = false
              this.$refs.listTable.toggleRowSelection(res, true)
            }
          })
        }
      },
      openCombinationDialog() {
        this.showCombination = true
        setTimeout(() => {
          this.$refs.combination.open()
        }, 200)
      },
      // 处理对话框关闭后事件
      handleParams(arr) {
        this.combinationList = this.combinationData.select_map
      },
      /**
       * 高级搜索
       */
      advanceSearch(arr) {
        this.advanceFilterData = arr
        this.commonSearch()
      },
      /**
       * 初始化筛选数据
       * @param  {Array} filters 筛选控件数组
       */
      initFilterData(filters) {
        let filterData = []
        _(filters).forEach((item) => {  // 处理筛选条件
          let filterModel = {}
          if (item.type == this.FILTER_RANGE || item.type == this.FILTER_DATERANGE) {
            filterModel = {
              field: item.filter_fields[0],
              type: item.type,
              from: '',
              to: ''
            }
          } else {
            filterModel = {
              field: item.filter_fields,
              value: '',
              type: item.type,
              isMultiple: item.is_multiple == 1
            }
            if (item.type == this.FILTER_SELECT &&
                item.is_multiple) { // 下拉框且多选
              filterModel.value = []
            }
            if (item.type == this.FILTER_CHECKBOX) { // 复选框
              filterModel.value = []
              filterModel.checked = false
            }
            if (item.type == this.FILTER_FOREIGNKEYCHECKBOX) { // 外键复选框
              filterModel.value = []
              filterModel.checked = false
            }
          }
          filterData.push(filterModel)
        })
        return filterData
      },
      getForeignKeyCheckboxData() {

      },
      handleRepeat() { // excel导入确认输入后，重新请求列表
        this.setLoading(true)
        this.getListConfig()
      },
      setLoading(value) {
        this.loading = value
      }
    },
    created() {
      this.loading = true
      this.$emit('setLoading', true)
      if (!_g.isRealEmpty(this.query)) {
        this.isJump = this.query.is_jump
        this.listQuery = decodeURIComponent(this.query.query)
        if (this.query.filterQuery) {
          this.filterQuery = decodeURIComponent(this.query.filterQuery)
        } else {
          this.filterQuery = ''
        }
        this.hasQueryFilter = true
      }
      this.getListConfig()
    },
    components: {
      listTable,
      chartsTable,
      editDeal,
      deleteDeal,
      importDeal,
      exportDeal,
      statusDeal,
      relateDeal,
      rangeFilter,
      datetimerangeFilter,
      combinationDialog,
      importlogDialog,
      repeatDialog,
      selfRender,
      dropdownRender,
      renderDialog,
      advanceDialog,
      emailDeal
    },
    computed: {
      // hasCommonBtn() {  // 公共区域是否有配置按钮
      //   return this.commonConfig.head_handle && this.commonConfig.head_handle.length > 0
      // },
      hasCommonFilter() { // 公共区域是否有配置筛选
        return this.commonFilter && this.commonFilter.length > 0
      },
      hasCombinationFilter() { // 公共区域是否有配置组合筛选
        if (this.listConfig && this.listConfig.filter_build) {
          return this.listConfig.filter_build.is_open === 1
        }
      },
      hasAdvanceFilter() {
        return this.advanceFilter && this.advanceFilter.length > 0
      },
      hasCombinationSelect() { // 组合筛选是否有使用权限
        if (this.listConfig && this.listConfig.filter_build) {
          return this.listConfig.filter_build.canUse === true
        }
      },
      hasCombinationButton() { // 组合筛选是否有配置权限
        if (this.listConfig && this.listConfig.filter_build) {
          return this.listConfig.filter_build.canBuild === true
        }
      },
      /**
       * 页面上显示的筛选控件
       */
      commonFilter() {
        if (this.listConfig.filter && this.listConfig.filter.length) {
          return _.filter(this.listConfig.filter, (item) => {
            return !item.show_type || item.show_type === this.FILTER_SHOW_NORMAL
          })
        } else {
          return []
        }
      },
      /**
       * 高级筛选控件列表
       */
      advanceFilter() {
        if (this.listConfig.filter && this.listConfig.filter.length) {
          return _.filter(this.listConfig.filter, (item) => {
            return item.show_type === this.FILTER_SHOW_ADVANCE
          })
        } else {
          return []
        }
      }
    },
    watch: {
      '$route'(to, from) { // 监听路由改变
        this.loading = true
        this.$emit('setLoading', true)
        this.isJump = to.query.is_jump
        this.listQuery = decodeURIComponent(to.query.query)
        this.beforeGetListData(this.listConfig)
      },
      query() {
        this.loading = true
        this.isJump = this.query.is_jump
        this.listQuery = decodeURIComponent(this.query.query)
        this.beforeGetListData(this.listConfig)
      },
      commonFilter(val) {
        if (!this.commonFilter.length) {
          return []
        }
        this.commonFilterData = this.initFilterData(this.commonFilter)
      },
      advanceFilter() {
        if (!this.advanceFilter.length) {
          return []
        }
        this.advanceFilterData = this.initFilterData(this.advanceFilter)
      }
    },
    mixins: [http, cmsConfig, dealMethod, dealCallback]
  }
</script>



// WEBPACK FOOTER //
// listRender.vue?909bf1f8